import type { FaireProductEntity } from "../../entity_types/product";

export const p_mtmakh3pay: FaireProductEntity = {
  token: "p_mtmakh3pay",
  type: "product",
  name: "Vancouver Swiss Water Decaf",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/a1d1836e46230fae3e28529a434e4a2d91900db251b2447e26d6698d5a070e1b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/238db2874ad2c0a43e8992a6fa7f3c46838eaf38398ca7dd965f40bfe228f1e3.png",
    "https://cdn.faire.com/fastly/60ab5b5c7be77449cadbf89cc9cfa2b328a58702a47e0fffba6c7d2e02a63bb3.png"
  ],
  priceDollars: 79,
  description: "Our Vancouver Swiss Water Decaf blend highlights candied almonds in a chocolaty background. The 100% chemical-free process results in 99.99% caffeine-free coffee. Anyone who enjoys a dessert-tasting coffee will love this.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:02.346Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
